
import goDialog from "../../../jsCom/go-dialog";
import {GoingUtils,AssertUtils} from "goingutils";
import EditorTypeUtils from "../../../common/editorTypeUtils";
import WinUtils from "../../../winUtils";


let goAclWinUtils = {
    //获取授权的用户名和id
    getAclWinIdsAndNames($elObj) {
        let names = [],
            ids = [];let dataForms=[];
        $elObj.find(".choice-item-com").each(function () {
            names.push($(this).attr("name"));
            ids.push($(this).attr("id"));
            dataForms.push($(this).attr("dataForm"));
        });
        return {ids, names,dataForms};
    },
    //获取查询区域的提交的数据
    getQuerySubmitData(item, targetObj, backJson) {
        let inputElId = `${targetObj.prefixCls}_${item["id"]}`;
        backJson[item["id"]] = $("#" + inputElId).val();
    },
    //获取编辑提交的数据
    getEditorSubmitData(item, targetObj, backJson) {
        let {ids, names} = goAclWinUtils.getAclWinIdsAndNames(
            $(`#${targetObj.prefixCls}_${item["id"]}`)
        );

        //如果关联id 不为空则返回关联id 的值
        if (AssertUtils.isNotEmpty(item["treeRelId"])) {
            //如果编数据下拉
            backJson[item["id"]] = names.join(GoingUtils.relChart);
            backJson[item["treeRelId"]] = ids.join(GoingUtils.relChart);
        } else {
            backJson[item["id"]] = names.join(GoingUtils.relChart);
            backJson[item["id"] + "_val"] = ids.join(GoingUtils.relChart);
        }
    },
    //执行确定按钮事件
    executeConfirm(aclCtl, itemObj, inputId) {
        //获取返回的ids
        let {selNames, backFlag} = aclCtl.getBackInfos(itemObj.config["count"], false);
        //如果返回false 则表示出现了提示信息
        if (backFlag === false) {
            return backFlag;
        }
        //需要返回数组的情况 才进行操作
        if (AssertUtils.isNotNull(selNames) && AssertUtils.isArray(selNames)) {
            $(`#${inputId}`).val(selNames.join(GoingUtils.relChart));
        }
        return true;
    },
    //初始化窗口事件
    initDefaultEvent($elObj, itemObj, inputId, targetObj, vueObj, initFlag) {
        //点击输入框 弹出下拉选择数据
        $elObj.click(function () {
            //需要设置相应的配置信息才行
            if (itemObj.config != null) {
                //确定按钮
                itemObj.config["confirmBtn"] = function (aclCtl) {
                    let flag = goAclWinUtils.executeConfirm(aclCtl, itemObj, inputId);
                    //如果返回了false 则表示有提示信息出现
                    if (flag !== false) {
                        //关闭窗口
                        WinUtils.closeParentCurWin();
                        //销毁授权对象的内存信息
                        goDialog.destructionAcl();
                    }
                };
                if (initFlag) {
                    //设置初始化数据函数
                    let {ids, names,dataForms} = goAclWinUtils.getAclWinIdsAndNames($("#" + inputId));
                    itemObj.config["initFun"] = function () {
                        return {
                            ids: ids.join(GoingUtils.relChart),
                            names: names.join(GoingUtils.relChart),
                            dataForms,
                        };
                    };
                }

                //设置授权窗口信息
                goDialog.attachAclWin(itemObj.config, vueObj);
            }
        });
    },
    //初始化单查询状态下的事件
    initSingleQueryEvent() {

    },
    //初始化查询状态下的事件
    initQueryEvent(parentObj, targetObj, vueObj) {
        $(parentObj)
            .find(".input-group-addon")
            .each(function () {
                let inputId = $(this).attr("inputId");
                let dropType = $(this).attr("dropType");
                //获取当前定义的字段属性
                let itemObj = (EditorTypeUtils.itemTemp)[inputId];
                if (dropType === "aclWin" && AssertUtils.isNotEmpty(inputId)) {
                    //初始化下拉的相关事件
                    goAclWinUtils.initDefaultEvent($(`#${inputId}_down`), itemObj, inputId, targetObj, vueObj, false);
                }
            });
    },
    //初始化编辑状态下的事件
    initEditorEvent(parentObj, targetObj, vueObj) {
        $(parentObj)
            .find(".go-ctl-aclWin-drop")
            .each(function () {
                let inputId = $(this).attr("inputId");
                //获取当前定义的字段属性
                let itemObj = (EditorTypeUtils.itemTemp)[inputId];
                //如果声明了
                if ($(this).attr("ctl") === "auto") {
                    //初始化下拉的相关事件
                    goAclWinUtils.initDefaultEvent($(`#${inputId}`), itemObj, inputId, targetObj, vueObj, true);
                }
            });
    }
};

export default goAclWinUtils;



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goForm/components/go-aclWin-ctl-event.js